// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__WT4y0","switchAndTextWrapper":"Switch_switchAndTextWrapper__5PIzO","switch":"Switch_switch__b9usM"};